import {
  Tooltip, TooltipContent, TooltipProvider, TooltipTrigger,
} from "@/components/ui/tooltip";

// Affiche une abréviation avec sa signification complète au survol et au tap
// (le soulignement pointillé indique qu'une légende est disponible). L'attribut
// `title` natif assure aussi l'accessibilité et le fonctionnement sur mobile.
export function Abbr({ short, full, className = "" }) {
  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <abbr
            data-testid={`abbr-${short.toLowerCase()}`}
            title={full}
            className={`cursor-help underline decoration-dotted decoration-slate-400 underline-offset-2 ${className}`}
          >
            {short}
          </abbr>
        </TooltipTrigger>
        <TooltipContent>{full}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
